<app-header></app-header>
<app-left-side></app-left-side>
<div class="page-content">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>